var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 96 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5856 19.0465L15.1579 1.17999V82.2409L25.5856 66.6904V19.0465Z",
    fill: "#FBC02D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6548 41.2558L22.8048 44.3393L32.3861 68.1259L42.3562 62.858L33.6548 41.2558Z",
    fill: "#FBC02D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5498 48.5334L21.4145 39.4608L36.6571 23.1133L44.3926 33.6873L30.5498 48.5334Z",
    fill: "#FBC02D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.965 21.4452H66.4784H77.7239L70.4216 32.8995H46.178L42.965 21.4452Z",
    fill: "#FBC02D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3103 49.7338C34.8596 46.4296 37.2799 42.7237 40.8885 42.7237H75.5566H95.7985L85.1238 49.265C84.5303 49.6287 83.8675 49.8644 83.1777 49.9572L39.0159 55.8961L36.3103 49.7338Z",
    fill: "#FBC02D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4891 42.7983L65.5353 26.9827L77.9922 19.4187L72.9254 34.9038L46.0703 51.2106L39.4891 42.7983Z",
    fill: "#FBC02D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1925 40.7088L80.3635 29.7185L90.9216 16.8055L95.7986 23.4717L82.1925 40.7088Z",
    fill: "#FBC02D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7901 24.7658L77.5748 20.1375L85.7327 31.2438L83.1343 41.5714L70.7901 24.7658Z",
    fill: "#FBC02D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8468 26.4717C88.8468 24.8149 90.1899 23.4717 91.8468 23.4717H92.7986C94.4554 23.4717 95.7986 24.8149 95.7986 26.4717V80.4574C95.7986 80.9445 95.6799 81.4242 95.453 81.8552L94.5012 83.6626C93.0421 86.4334 88.8468 85.3963 88.8468 82.2647V26.4717Z",
    fill: "#FBC02D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7721 21.4452L77.7239 21.4452V37.4885L70.7721 41.7104V21.4452Z",
    fill: "#FBC02D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4517 53.8578C86.5752 55.7806 86.6294 57.7105 86.614 59.6405L43.3083 59L86.4517 53.8578Z",
    fill: "#FBC02D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6904af03d7397d5de8431629b8848b0a.svg";
export { ForwardRef as ReactComponent };